import { useHistory } from 'react-router';
import { LayoutStoreInstance } from '../LayoutStore';
import i18n from '@/utils/i18n';
import { getGlobalContext } from '@/utils/window';

export type CommunicatorGetOptions = {
  doNotUsePosingRoleHeader?: boolean;
};

export class Communicator {
  static PutData(url: string, data: any): Promise<Response> {
    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        // @ts-ignore
        'posing-role': getGlobalContext().posingRole,
      },
      body: data != null ? JSON.stringify(data) : null,
    }).then((result) => Communicator.handleFetchResult(result));
  }

  static PutFormData(url: string, data: FormData): Promise<Response> {
    return fetch(url, {
      method: 'PUT',
      body: data,
      // @ts-ignore
      headers: { 'posing-role': getGlobalContext().posingRole },
    }).then((result) => Communicator.handleFetchResult(result));
  }

  static PostData(
    url: string,
    data: any,
    headers: any = {},
  ): Promise<Response> {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
        // @ts-ignore
        'posing-role': getGlobalContext().posingRole,
      },
      body: JSON.stringify(data),
    }).then((result) => Communicator.handleFetchResult(result));
  }

  static PostFileUpload(
    url: string,
    fileData: File,
    headers: any = {},
  ): Promise<Response> {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
        // @ts-ignore
        'posing-role': getGlobalContext().posingRole,
      },
      body: fileData,
    }).then((result) => Communicator.handleFetchResult(result));
  }

  static PostFormData(url: string, data: FormData): Promise<Response> {
    return fetch(url, {
      method: 'POST',
      body: data,
      // @ts-ignore
      headers: { 'posing-role': getGlobalContext().posingRole },
    })
      .then((result) => {
        if (!result.ok) throw result;
        return result;
      })
      .then((result) => Communicator.handleFetchResult(result));
  }

  static DeleteData(url: string, data: any): Promise<Response> {
    return fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        // @ts-ignore
        'posing-role': getGlobalContext().posingRole,
      },
      body: JSON.stringify(data),
    }).then((result) => Communicator.handleFetchResult(result));
  }

  static Get(
    url: string,
    parameters: any,
    options: CommunicatorGetOptions = {},
  ): Promise<Response> {
    var query = Object.keys(parameters)
      .map(
        (k) => encodeURIComponent(k) + '=' + encodeURIComponent(parameters[k]),
      )
      .join('&');

    const headers = {};
    if (!options.doNotUsePosingRoleHeader) {
      // @ts-ignore
      headers['posing-role'] = getGlobalContext().posingRole;
    }

    return fetch(url + '?' + query, {
      method: 'GET',
      headers,
    }).then((result) => Communicator.handleFetchResult(result));
  }

  static handleFetchResult(result: Response) {
    if (result.ok) {
      return result;
    }
    if (result.status === 403) {
      LayoutStoreInstance.setError(i18n.t('Common:unauthorized'));
      alert(i18n.t('Common:unauthorized'));
    }
    throw result;
  }
}
